import axios from 'axios'
import { inject } from 'vue'

let API_URL = `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_URL}/api/`

const api = axios.create({
  baseURL: API_URL,
})

// Optional: Set request/response interceptors
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token')    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error),
)

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error)
    return Promise.reject(error)
  },
)

export default {
  install(app) {
    app.config.globalProperties.$api = api
    app.provide('api', api)
  },
}

// For script setup convenience
export const useApi = () => inject('api')
export { api }
